// Lee un cartel de evento en el navegador con OCR gratuito (Tesseract.js, sin claves ni coste)
// y propone los datos del formulario. Es una ayuda: siempre hay que revisar el resultado.

const MESES = {
  january: 1, enero: 1, janvier: 1, february: 2, febrero: 2, 'février': 2, fevrier: 2,
  march: 3, marzo: 3, mars: 3, april: 4, abril: 4, avril: 4, may: 5, mayo: 5, mai: 5,
  june: 6, junio: 6, juin: 6, july: 7, julio: 7, juillet: 7, august: 8, agosto: 8, 'août': 8, aout: 8,
  september: 9, septiembre: 9, setiembre: 9, septembre: 9, october: 10, octubre: 10, octobre: 10,
  november: 11, noviembre: 11, novembre: 11, december: 12, diciembre: 12, 'décembre': 12, decembre: 12,
};
const RX_MES = Object.keys(MESES).sort((a, b) => b.length - a.length).join('|');
const PALABRAS_CORTAS = new Set(['a', 'y', 'o', 'e', 'de', 'la', 'el', 'en', 'to', 'of', 'in', 'or', 'at', 'an', 'is', 'on', 'it', 'no', 'se', 'su', 'un', 'al', 'du', 'le', 'et', 'ou', 'à', 'un']);

const pad = (n) => String(n).padStart(2, '0');
const esMayus = (s) => /[A-ZÁÉÍÓÚÑ]/.test(s) && s === s.toUpperCase() && !/[a-záéíóúñ]/.test(s);
const titulo = (s) => s.toLowerCase().replace(/(^|[\s-])([a-záéíóúñ])/g, (_, a, b) => a + b.toUpperCase());

function limpiarLinea(l) {
  const t = l.replace(/[|<>_~•©®]+/g, ' ').replace(/\s+/g, ' ').trim().split(' ');
  while (t.length > 3) {
    const u = t[t.length - 1];
    const ruido = !/[a-záéíóúñ0-9]/i.test(u) || (u.length <= 3 && esMayus(u) && !PALABRAS_CORTAS.has(u.toLowerCase()))
      || (u.length <= 2 && !PALABRAS_CORTAS.has(u.toLowerCase()) && !/[.,;:!?)]$/.test(u));
    if (ruido) t.pop(); else break;
  }
  return t.join(' ');
}

function parseFecha(texto, hoy) {
  let m = texto.match(new RegExp(`(\\d{1,2})(?:st|nd|rd|th|º|er)?\\s*(?:de\\s+)?(${RX_MES})\\b(?:\\s*(?:de\\s+)?(\\d{4}))?`, 'i'));
  let dia, mes, anio;
  if (m) { dia = +m[1]; mes = MESES[m[2].toLowerCase()]; anio = m[3] ? +m[3] : null; }
  else {
    m = texto.match(new RegExp(`\\b(${RX_MES})\\.?\\s+(\\d{1,2})(?:st|nd|rd|th)?\\b(?:,?\\s*(\\d{4}))?`, 'i'));
    if (m) { mes = MESES[m[1].toLowerCase()]; dia = +m[2]; anio = m[3] ? +m[3] : null; }
    else {
      m = texto.match(/\b(\d{1,2})[/.-](\d{1,2})[/.-](\d{2,4})\b/);
      if (!m) return null;
      dia = +m[1]; mes = +m[2]; anio = +m[3] < 100 ? 2000 + +m[3] : +m[3];
    }
  }
  if (!dia || !mes || dia > 31 || mes > 12) return null;
  if (!anio) {
    const y = +hoy.slice(0, 4);
    anio = `${y}-${pad(mes)}-${pad(dia)}` >= hoy ? y : y + 1;
  }
  return `${anio}-${pad(mes)}-${pad(dia)}`;
}

function aMinutos(h, mi, ap) {
  let hh = +h;
  if (ap) { ap = ap.toLowerCase(); if (ap === 'pm' && hh < 12) hh += 12; if (ap === 'am' && hh === 12) hh = 0; }
  return hh * 60 + +mi;
}

export function parsearCartel(texto, hoy) {
  const out = {};
  const bruto = String(texto || '').replace(/\r/g, '');
  const lineas = bruto.split('\n').map((l) => l.trim());
  const llenas = lineas.filter(Boolean);
  if (!llenas.length) return out;

  // Título: primeras líneas en mayúsculas (o la primera línea).
  let i = 0; const tl = [];
  while (i < llenas.length && esMayus(llenas[i]) && tl.length < 3) { tl.push(llenas[i]); i++; }
  if (!tl.length) { tl.push(llenas[0]); i = 1; }
  const nombre = titulo(limpiarLinea(tl.join(' ')));
  if (nombre) { out.nombre_es = nombre; out.nombre_en = nombre; }

  // Fecha
  const fecha = parseFecha(bruto, hoy);
  if (fecha) out.fecha = fecha;

  // Hora (rango o única) y duración
  const horas = [...bruto.matchAll(/(\d{1,2})[:.h](\d{2})\s*(AM|PM)?/gi)];
  if (horas.length) {
    const ini = aMinutos(horas[0][1], horas[0][2], horas[0][3] || (horas[1] && horas[1][3]));
    out.hora_inicio = `${pad(Math.floor(ini / 60) % 24)}:${pad(ini % 60)}`;
    if (horas[1]) {
      const fin = aMinutos(horas[1][1], horas[1][2], horas[1][3]);
      if (fin > ini) out.duracion_minutos = fin - ini;
    }
  }
  const d = bruto.match(/(\d+(?:[.,]\d+)?)\s*(hours?|horas?|heures?|hrs?|h)\b/i);
  if (!out.duracion_minutos && d) out.duracion_minutos = Math.round(parseFloat(d[1].replace(',', '.')) * 60);
  const dm = bruto.match(/(\d+)\s*(minutes?|minutos?|min)\b/i);
  if (!out.duracion_minutos && dm) out.duracion_minutos = +dm[1];

  // Precio
  const p = bruto.match(/(\d+(?:[.,]\d+)?)\s*(€|eur\b|euros?)/i);
  if (p) out.precio_euros = parseFloat(p[1].replace(',', '.'));
  else if (/\b(free|gratis|gratuit)\b/i.test(bruto)) out.precio_euros = 0;

  // Lugar: línea con STUDIO/ESTUDIO + la siguiente
  const iL = llenas.findIndex((l) => /\b(studio|estudio|studios)\b/i.test(l) && l.length < 60);
  if (iL >= 0) {
    const sig = llenas[iL + 1] && !/instagram|www\.|@|\+\d/i.test(llenas[iL + 1]) ? limpiarLinea(llenas[iL + 1]) : '';
    out.lugar = [limpiarLinea(llenas[iL]), sig].filter(Boolean).join(', ');
  }

  // Descripción corta: línea(s) tras el título que no estén en mayúsculas
  const corta = []; let j = i;
  while (j < llenas.length && corta.length < 2 && !esMayus(llenas[j]) && llenas[j].length > 15) { corta.push(llenas[j]); j++; }
  if (corta.length) { const c = limpiarLinea(corta.join(' ')).slice(0, 200); out.descripcion_es = c; out.descripcion_en = c; }

  // Descripción larga: bloques de frases largas (párrafos) antes de la línea de la fecha
  const finIdx = lineas.findIndex((l) => /\b(sunday|monday|tuesday|wednesday|thursday|friday|saturday|domingo|lunes|martes|mi[eé]rcoles|jueves|viernes|s[aá]bado|dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)\b/i.test(l) || new RegExp(`\\b(${RX_MES})\\b`, 'i').test(l));
  const zona = (finIdx > 0 ? lineas.slice(0, finIdx) : lineas).join('\n').split(/\n\s*\n/);
  const parrafos = zona.map((b) => b.split('\n').map((l) => l.trim()).filter(Boolean))
    .filter((ls) => ls.length && ls.filter((l) => l.length >= 28).length >= Math.max(1, Math.ceil(ls.length / 2)) && ls.join(' ').split(' ').length >= 8)
    .map((ls) => limpiarLinea(ls.map(limpiarLinea).join(' ')))
    .filter((t) => !(out.descripcion_es && out.descripcion_es.startsWith(t.slice(0, 20))));
  if (parrafos.length) { const l = parrafos.join('\n\n'); out.descripcion_larga_es = l; out.descripcion_larga_en = l; }
  return out;
}

function cargarTesseract() {
  if (window.Tesseract) return Promise.resolve(window.Tesseract);
  return new Promise((resolve, reject) => {
    const s = document.createElement('script');
    s.src = 'https://cdn.jsdelivr.net/npm/tesseract.js@5.1.1/dist/tesseract.min.js';
    s.onload = () => resolve(window.Tesseract);
    s.onerror = () => reject(new Error('No se pudo cargar el lector de texto'));
    document.head.appendChild(s);
  });
}

export async function leerCartelLocal(file) {
  const T = await cargarTesseract();
  const r = await T.recognize(file, 'eng+spa');
  const hoy = new Intl.DateTimeFormat('sv-SE', { timeZone: 'Europe/Madrid' }).format(new Date());
  return parsearCartel(r.data.text, hoy);
}
